import { useEffect, useState } from 'react';
import { getInstallState, subscribeInstall, promptInstall } from '../pwa/installPrompt';

export default function usePwaInstall() {
    const [state, setState] = useState(getInstallState);

    useEffect(() => {
        const update = () => setState(getInstallState());
        update();
        return subscribeInstall(update);
    }, []);

    return {
        ...state,
        // mostra o botão quando o navegador permite instalar,
        // ou no iPhone/iPad (onde a instalação é manual pelo Safari)
        showInstall: !state.installed && (state.canPrompt || state.ios),
        install: promptInstall,
    };
}
